import ConstCode from "../../ConstCode";
import { enTokenCMD } from "../../classTalk/CodeEnum";
import { base64ToBlob } from "../../func/ExportFunction";

import {
    sendChatMsg,
    sendChatInkMemo,
    sendChatVoiceMemo,
    sendUserLoginStatus,
    sendJsonInfoForPbl,
    sendTokenDataForPbl,
    getMySmallGroupSendKey
} from "../../RabbitmqClient";

import {
    appendSendFileShare
} from "../../../modules/classTalkLive";

/**
 * Pentalk WiFi에서 클래스톡으로 텍스트 메시지를 보낼 경우
 * Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {String} messageValue - 전달할 텍스트 메시지
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2025-07-08.
 */
export const sendChatMsgHelper = (messageValue, nickname) => {
    /**
     * 2025-07-08 ... Pentalk WiFi Pbl에서는 아직 이모티콘 기능이 구현되어 있지 않으므로 
     * Pbl helper에서는 [ emoMIDno = -1 ]을 임시 고정값으로 설정함
     * 추후 기능이 구현된 후 값을 매개변수로 전달받아야 함 ... by hjkim
     */
    let mode = "whisper"; // 20260107 수정 ... Pentalk WiFi Pbl에서는 귓속말로만 전송해야함 ... by hjkim
    let emoMIDno = -1;

    let senderName = nickname ? nickname : "";
    if (senderName === "") {
        console.log("sendChatMsgHelper - Need to get the user nickname from store.getState().");
        let store = window.hiclasstv.store;
        const { user } = store.getState();
        const { userNickname } = user;
        senderName = userNickname;
    }
    console.log("sendChatMsgHelper - senderName => ", senderName);

    sendChatMsg(mode, messageValue, emoMIDno, senderName);
}

/**
 * Pentalk WiFi에서 클래스톡으로 잉크 메모 메시지를 보낼 경우
 * Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {Blob} imgData - 전달할 잉크 메모 데이터 (이미지 파일 형식(blob))
 * @param {String} nickname - 전달할 사용자 닉네임
 * @#param {Number} userSeq - 전달할 사용자 시퀀스
 * @since 2025-07-10.
 */
export const sendChatInkMemoHelper = (imgData, nickname) => {
    let mode = "whisper"; // 20260107 수정 ... Pentalk WiFi Pbl에서는 귓속말로만 전송해야함 ... by hjkim

    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userSeq } = user;
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    let senderName = nickname ? nickname : "";
    if (senderName === "") {
        console.log("sendChatInkMemoHelper - Need to get the user nickname from store.getState().");
        const { userNickname } = user;
        senderName = userNickname;
    }
    console.log("sendChatInkMemoHelper - senderName => ", senderName);

    sendChatInkMemo(mode, imgData, liveSeq, userSeq, senderName);
}

/**
 * Pentalk WiFi에서 클래스톡으로 보이스 메모 메시지를 보낼 경우
 * Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {Blob} voiceData - 전달할 음성 메모 데이터 (오디오 파일 형식(blob))
 * @param {String} nickname - 전달할 사용자 닉네임
 * @#param {Number} userSeq - 전달할 사용자 시퀀스
 * @since 2025-07-10.
 */
export const sendChatVoiceMemoHelper = (voiceData, nickname) => {
    let mode = "whisper"; // 20260107 수정 ... Pentalk WiFi Pbl에서는 귓속말로만 전송해야함 ... by hjkim

    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userSeq } = user;
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    let senderName = nickname ? nickname : "";
    if (senderName === "") {
        console.log("sendChatVoiceMemoHelper - Need to get the user nickname from store.getState().");
        const { userNickname } = user;
        senderName = userNickname;
    }
    console.log("sendChatVoiceMemoHelper - senderName => ", senderName);

    sendChatVoiceMemo(mode, voiceData, liveSeq, userSeq, senderName);
}

/**
 * 그룹(PBL)이 선생님에게 파일을 전송할 때, 선생님 쪽 서버에 실제로 저장될 파일 이름을 생성하는 헬퍼.
 *
 * 기존에는 학생(그룹)이 보낸 파일의 원본 파일명 그대로 서버에 저장되고 있었는데,
 * 원본 파일명을 그대로 쓰면 그룹끼리 파일명이 겹치거나 특수문자/경로 문제가 생길 수 있어서
 * "랜덤문자열 + GroupSeq(=PBL 그룹 로그인 시 userSeq)" 조합의 새 파일명으로 저장하도록 함.
 * 화면에 보여줄 말풍선 텍스트는 원본 파일명(filename)을 그대로 유지하고,
 * 이 storageFileName은 REST API(/upload, /uploadSplit) 호출 시 실제 저장 파일명으로만 사용됨.
 *
 * @param {String} fileName - 업로드할 원본 파일 이름 (확장자 포함)
 * @param {Number|String} groupSeq - 그룹 시퀀스 (PBL 그룹 로그인 시의 userSeq)
 * @returns {String} 새로 생성된 저장용 파일 이름 (확장자 포함)
 * @since 2026-07-14.
 */
const generatePblUploadStorageFileName = (fileName, groupSeq) => {
    const dotIdx = fileName ? fileName.lastIndexOf(".") : -1;
    const ext = dotIdx > -1 ? fileName.substring(dotIdx) : "";

    const randomStr = Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
    const seqPart = (groupSeq !== undefined && groupSeq !== null && groupSeq !== "") ? groupSeq : "0";

    return `${randomStr}${seqPart}${ext}`;
}

/**
 * 실제로 SFU(백엔드) 서버에 파일을 업로드하도록 dispatch하는 내부 공용 로직
 *
 * sendChatFileShareHelper(단일 전달)과 sendChatFileShareChunkHelper(분할 전달, 청크 조립 완료 시)
 * 양쪽에서 공통으로 사용하며, 이 부분은 업로드 방식이 바뀌어도 그대로 유지되어야 함
 * (= SFU 서버로 파일을 보내는 부분) ... by hjkim
 *
 * @param {Blob} blobData - 업로드할 파일 데이터 (Blob)
 * @param {String} fileName - 업로드할 파일 이름
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2026-07-13.
 */
const dispatchFileShareUpload = (blobData, fileName, nickname) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    // const { classTalkLive } = store.getState();
    const { userSeq } = user;
    const { isMixedClassMember, performLiveInfo } = live;
    const { liveSeq, teacher_info, mixedClassStatus } = performLiveInfo;
    // const { isWhisperModalOpened, web_isWhisper } = classTalkLive;
    const teacherSeq = teacher_info.userSeq;

    let userNickname = nickname ? nickname : "";
    if (userNickname === "") {
        console.log("dispatchFileShareUpload - Need to get the user nickname from store.getState().");
        // const { userNickname } = user;
        userNickname = user.userNickname;
    }
    console.log("dispatchFileShareUpload - final userNickname => ", userNickname);

    // 20260714 추가: 선생님 쪽 서버에 실제 저장될 파일명은 원본 파일명이 아니라
    // "랜덤문자열 + GroupSeq(userSeq)" 조합의 새 파일명을 쓰도록 함 ... by hjkim
    const storageFileName = generatePblUploadStorageFileName(fileName, userSeq);
    console.log(`dispatchFileShareUpload - originalFileName[${fileName}] -> storageFileName[${storageFileName}]`);

    let sendData = {
        mode: "new-web",
        command: enTokenCMD.ct_UploadAndShareFiles,
        data: blobData,  // Blob 형태로 전달
        filename: fileName,           // 말풍선 등 화면 표시용 원본 파일명 (그대로 유지)
        storageFileName,              // 선생님 쪽 서버에 실제 저장될 파일명 (REST API 호출 시 사용)
        teacherSeq,
        liveSeq,
        userSeq,
        userNickname,
        isWhisper: true,
        smallGroupKey: getMySmallGroupSendKey(),
        isMixedClassMember,
        mixedClassStatus,
        kind: "pbl-content"
    };

    if (isMixedClassMember) {
        const { mixedClassInfo } = live;

        sendData = {
            ...sendData,
            localServerSeq: mixedClassInfo.localServerSeq,
            localLiveSeq: mixedClassInfo.localLiveSeq,
            localTeacherSeq: mixedClassInfo.localTeacherSeq
        };
    }

    console.log("dispatchFileShareUpload - final sendData => ", sendData);

    store.dispatch(appendSendFileShare(sendData));
}

/**
 * Pentalk WiFi에서 클래스톡으로 파일을 공유할 경우
 * Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 *
 * (기존 방식 - 파일 데이터를 한 번에 통째로 전달받는 경우 사용.
 *  큰 파일은 WebView 경계를 한 번에 못 건너올 수 있으므로 sendChatFileShareChunkHelper 사용을 권장) ... by hjkim
 *
 * @param {String|Blob} fileData - 전달할 파일 데이터 (Base64 인코딩 문자열 또는 Blob 파일 데이터)
 * @param {String} fileName - 전달할 파일 이름
 * @param {String} mimeType - 전달할 파일의 MIME 타입 (C#에서 전달받을 경우)
 * @param {String} nickname - 전달할 사용자 닉네임
 * @#param {Number} userSeq - 전달할 사용자 시퀀스
 * @since 2025-07-10.
 * @modify 2026-01-07. (File 데이터 형식 변경)
 */
export const sendChatFileShareHelper = (fileData, fileName, mimeType, nickname) => {
    let blobData;

    // fileData가 Base64 문자열인 경우 Blob으로 변환
    if (typeof fileData === "string") {
        blobData = base64ToBlob(fileData, mimeType);
    } else {
        // 이미 Blob인 경우 그대로 사용
        blobData = fileData;
    }

    dispatchFileShareUpload(blobData, fileName, nickname);
}

/**
 * Pentalk WiFi PBL에서 큰 파일을 나눠(split) 전달할 경우 사용하는 Helper 메서드
 *
 * WPF/Android 쪽에서 파일을 여러 조각(chunk)의 Base64 문자열로 나눠 여러 번 호출하면,
 * 여기서 받은 조각들을 순서대로 모았다가 마지막 조각이 도착했을 때 하나의 Blob으로
 * 합쳐서 dispatchFileShareUpload를 호출함 (= 기존 SFU 업로드 로직은 그대로 재사용)
 *
 * @param {String} uploadId - 업로드 건을 구분하기 위한 고유 식별자 (같은 파일의 청크는 동일한 값)
 * @param {String} chunkData - Base64로 인코딩된 청크(조각) 데이터
 * @param {Number} chunkSeq - 청크 순번 (0부터 시작)
 * @param {Number} chunkTotal - 전체 청크 개수
 * @param {String} fileName - 전달할 파일 이름
 * @param {String} mimeType - 전달할 파일의 MIME 타입
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2026-07-13.
 */
const fileShareChunkBufferMap = new Map();

export const sendChatFileShareChunkHelper = (uploadId, chunkData, chunkSeq, chunkTotal, fileName, mimeType, nickname) => {
    console.log(`sendChatFileShareChunkHelper - uploadId[${uploadId}], chunkSeq[${chunkSeq}], chunkTotal[${chunkTotal}], fileName[${fileName}]`);

    if (uploadId === undefined || uploadId === null || uploadId === "") {
        console.log("sendChatFileShareChunkHelper - uploadId is invalid => ", uploadId);
        return;
    }

    if (!fileShareChunkBufferMap.has(uploadId)) {
        fileShareChunkBufferMap.set(uploadId, {
            chunks: new Array(chunkTotal),
            receivedCount: 0,
            fileName,
            mimeType,
            nickname
        });
    }

    const entry = fileShareChunkBufferMap.get(uploadId);

    try {
        const chunkBlob = base64ToBlob(chunkData, mimeType || entry.mimeType);

        if (entry.chunks[chunkSeq] === undefined) {
            entry.receivedCount += 1;
        }
        entry.chunks[chunkSeq] = chunkBlob;
    } catch (error) {
        console.log("sendChatFileShareChunkHelper - failed to decode chunk => ", error);
        fileShareChunkBufferMap.delete(uploadId);
        return;
    }

    if (entry.receivedCount >= chunkTotal) {
        console.log("sendChatFileShareChunkHelper - all chunks received. assembling Blob and dispatch upload.");

        const finalBlob = new Blob(entry.chunks, { type: mimeType || entry.mimeType });
        fileShareChunkBufferMap.delete(uploadId);

        dispatchFileShareUpload(finalBlob, entry.fileName || fileName, nickname || entry.nickname);
    }
}

/**
 * Pentalk WiFi에서 사용자 상태 값 변경을 알려야 할 경우
 * Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @#param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {Number} userStatus - 전달할 사용자 상태값
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2025-07-10.
 */
export const sendUserLoginStatusHelper = (/* userSeq,  */userStatus, nickname) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userSeq } = user;
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    let senderName = nickname ? nickname : "";
    if (senderName === "") {
        console.log("sendUserLoginStatusHelper - Need to get the user nickname from store.getState().");
        const { userNickname } = user;
        senderName = userNickname;
    }
    console.log("sendUserLoginStatusHelper - senderName => ", senderName);

    sendUserLoginStatus(liveSeq, userSeq, userStatus, senderName);
}

/**
 * Pentalk WiFi에서 Pentalk Pro로 Json 유형의 메시지 정보 데이터를
 * 전달해야 할 경우 Pentalk Pro에서 RBMQ 메시지로 보내기 위해
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * @param {JSON} data - 전달할 JSON 데이터
 * @since 2025-07-16.
 */
export const sendContentDataHelper = (data) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    // Json 데이터 전달
    sendJsonInfoForPbl("handsup", "PBL_Action", {
        liveSeq,
        userSeq: user.userSeq,
        ...data
    });
}

/**
 * Pentalk WiFi에서 받은 Token 데이터를
 * Pentalk Pro에 전달해야 하는 경우
 * Pro 형식에 맞게 변환을 돕는 Helper 메서드
 * 
 * 기존에는 Base64 문자열 형태의 Token 데이터만 처리했으나,
 * WiFi PBL의 inkchat에서는 JSON 배열 문자열 형태로 잉크 Token을 전달하므로
 * 전달받은 데이터를 Raw Binary Token(Uint8Array) 형태로 변환한 뒤
 * Pentalk Pro RBMQ 전송 형식에 맞게 Packetizing하여 전달함
 * 
 * @param {String|Array|Uint8Array|ArrayBuffer} tokenData - 전달할 Token 데이터
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2025-07-23.
 * @modify 2026-07-08. (WiFi PBL 잉크 Token 전송을 위해 JSON 배열/TypedArray/ArrayBuffer 입력 지원)
 */
export const sendTokenDataHelper = (tokenData, nickname) => {
    console.log("sendTokenDataHelper - tokenData => ", tokenData);

    const rawBinData = getTokenRawBinaryData(tokenData);
    if (rawBinData === null) {
        console.log("sendTokenDataHelper - invalid tokenData => ", tokenData);
        return;
    }
    console.log("sendTokenDataHelper - rawBinData => ", rawBinData);

    let senderName = nickname ? nickname : "";
    if (senderName === "") {
        console.log("sendTokenDataHelper - Need to get the user nickname from store.getState().");
        let store = window.hiclasstv.store;
        const { user } = store.getState();
        const { userNickname } = user;
        senderName = userNickname;
    }
    console.log("sendTokenDataHelper - senderName => ", senderName);

    sendTokenDataForPbl(rawBinData, senderName);
}

/**
 * 기존 sendTokenDataHeler 오타 함수명 호환용 Wrapper 메서드
 * 
 * 외부 C# 또는 WebView에서 이미 기존 함수명을 호출하고 있을 수 있으므로
 * 기존 함수명은 유지하고 내부 처리는 sendTokenDataHelper로 위임함
 * 
 * @param {String|Array|Uint8Array|ArrayBuffer} tokenData - 전달할 Token 데이터
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2026-07-08.
 */
export const sendTokenDataHeler = (tokenData, nickname) => {
    sendTokenDataHelper(tokenData, nickname);
}

/**
 * Pentalk WiFi PBL에서 전달받은 Token 데이터를 Raw Binary Token 데이터로 변환하는 메서드
 * 
 * Base64 문자열, JSON 배열 문자열, inkchat JSON 객체, Array, TypedArray, ArrayBuffer를
 * 모두 Uint8Array 형태로 변환하여 Pentalk Pro RBMQ Token 전송에서 사용할 수 있도록 함
 * 
 * @param {String|Array|Uint8Array|ArrayBuffer|Object} tokenData - 변환할 Token 데이터
 * @returns {Uint8Array|null} 변환된 Raw Binary Token 데이터
 * @since 2026-07-08.
 */
const getTokenRawBinaryData = (tokenData) => {
    if (tokenData === undefined || tokenData === null) return null;

    if (tokenData instanceof Uint8Array) {
        return tokenData;
    }

    if (ArrayBuffer.isView(tokenData)) {
        return new Uint8Array(tokenData.buffer, tokenData.byteOffset, tokenData.byteLength);
    }

    if (tokenData instanceof ArrayBuffer) {
        return new Uint8Array(tokenData);
    }

    if (Array.isArray(tokenData)) {
        return new Uint8Array(tokenData);
    }

    if (typeof tokenData === "object" && tokenData.data !== undefined) {
        return getTokenRawBinaryData(tokenData.data);
    }

    if (typeof tokenData === "string") {
        const trimmedTokenData = tokenData.trim();
        if (trimmedTokenData === "") return null;

        if (trimmedTokenData.startsWith("{")) {
            try {
                const tokenObject = JSON.parse(trimmedTokenData);
                if (tokenObject && tokenObject.data !== undefined) {
                    return getTokenRawBinaryData(tokenObject.data);
                }
            } catch (error) {
                console.log("getTokenRawBinaryData - JSON object token parse failed => ", error);
                return null;
            }
        }

        if (trimmedTokenData.startsWith("[")) {
            try {
                const tokenArray = JSON.parse(trimmedTokenData);
                if (Array.isArray(tokenArray)) {
                    return new Uint8Array(tokenArray);
                }
            } catch (error) {
                console.log("getTokenRawBinaryData - JSON token parse failed => ", error);
                return null;
            }
        }

        try {
            const rawBinString = window.atob(trimmedTokenData);
            const len = rawBinString.length;
            let rawBinData = new Uint8Array(len);

            for (let i = 0; i < len; i++) {
                rawBinData[i] = rawBinString.charCodeAt(i);
            }

            return rawBinData;
        } catch (error) {
            console.log("getTokenRawBinaryData - base64 token parse failed => ", error);
            return null;
        }
    }

    return null;
}